import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { ProjectFilesAccessErrorMessageComponent } from '@portal-core/project-files/components/project-files-access-error-message/project-files-access-error-message.component';

@NgModule({
  declarations: [
    ProjectFilesAccessErrorMessageComponent
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatIconModule
  ],
  exports: [
    ProjectFilesAccessErrorMessageComponent
  ]
})
export class ProjectFilesAccessErrorMessageModule { }
